// extracted by mini-css-extract-plugin
export default {"loginModal":"LoginModal_loginModal__AnjIW","notRegisteredBorder":"LoginModal_notRegisteredBorder__lsf4D"};